import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StyledCardHeaderText, StyledPreview, StyledSummaryCard } from './styles'
import { Icon, Row, T } from '@nv/react-commons/src/Components'
import { Colors } from 'themes'
import { faEdit } from '@fa-pro-light/faEdit'
import { Vspace } from 'components/Vspace'
import { CenterText } from 'components/CenterText'
import { Text } from 'components/Text'
import { ShortText } from 'containers/FPLMMCCOrderCreation/styles'
import { SERVICE_TYPE } from 'containers/FPLCommon/constants'

const StyledRow = styled(Row)`
  flex: 1;
  width: 50%;
  margin-right: 16px;
`

const Preview = ({ id, asCard, order, selected, rowNum, onSelect, serviceType }) => {
  const { completed, name } = order
  return (
    <StyledPreview
      asCard={asCard}
      onClick={() => {
        !selected && onSelect(id)
      }}
      data-analyticsid='4plOCEditManualOrder'
      data-testid='4plOrderSummary'
      type='flex'
      justify='space-between'
      align='middle'
      selected={selected}
    >
      <StyledRow>
        <Text type='bold' size={12} color={Colors.pinkishGrey} inline>
          <T id={serviceType === SERVICE_TYPE.B2B_BUNDLE ? 'bundle_x' : 'order_x'} values={{ x: rowNum + 1 }} />
        </Text>
        <ShortText type='bold' size={14}>
          {name}
        </ShortText>
      </StyledRow>
      {(selected || completed) && (
        <Text color={Colors.apricot} style={{ marginRight: 8 }}>
          <T id={completed ? 'completed' : 'editing'} />
        </Text>
      )}
      {!selected && <Icon color={Colors.warmGrey} type={asCard ? 'medium' : 'small'} icon={faEdit} gap={1} />}
    </StyledPreview>
  )
}

Preview.propTypes = {
  asCard: PropTypes.bool,
  id: PropTypes.number,
  onSelect: PropTypes.func,
  order: PropTypes.object,
  selected: PropTypes.bool,
  serviceType: PropTypes.number
}

const OrderSummary = ({ orders, selectedId, onSelectOrder, serviceType }) => {
  const orderSummaryHeader = () => {
    return (
      <Row type='flex' align='middle' justify='space-between'>
        <StyledCardHeaderText>
          <T id={serviceType === SERVICE_TYPE.B2B_BUNDLE ? 'total_bundles_capitalized' : 'total_orders'} />
        </StyledCardHeaderText>
        <StyledCardHeaderText>{orders.length}</StyledCardHeaderText>
      </Row>
    )
  }

  return (
    <StyledSummaryCard title={orderSummaryHeader()}>
      {orders.length ? (
        orders.map((order, i) => (
          <Preview
            key={order.id}
            id={order.id}
            rowNum={i}
            order={order}
            onSelect={onSelectOrder}
            selected={order.id === selectedId}
            serviceType={serviceType}
          />
        ))
      ) : (
        <>
          <Vspace height={24} />
          <CenterText color={Colors.pinkishGrey}>
            <T id='key_order_to_begin' />
          </CenterText>
        </>
      )}
    </StyledSummaryCard>
  )
}

OrderSummary.propTypes = {
  orders: PropTypes.array,
  selectedId: PropTypes.number,
  onSelectOrder: PropTypes.func,
  onClickContinue: PropTypes.func,
  serviceType: PropTypes.number
}

OrderSummary.defaultProps = {
  orders: [],
  selectedId: 0
}

export { OrderSummary, Preview }
